export default __webpack_public_path__ + "static/media/AWS_Infrastructure.e2063200.svg";